/*
const container = document.querySelector("#tabsContainer");
const tabList = container.querySelector('[role="tablist"]');
const tabUnderline = container.querySelector(".tabUnderline");
const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
const tabPanels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

let focusedTab = 0;

tabList.addEventListener("keydown", handleTabListKeydown);

for (const tab of tabs) {
  tab.addEventListener("click", handleTabClick);
}

function updateTabFocus() {
  // Give each tab an index of -1 so that it cannot be focused by normal means (e.g. with the 'tab' key).
  for (const tab of tabs) {
    tab.setAttribute("tabindex", -1);
  }
  // Give only the currently focused tab an index of 0 so that it can be navigated to with the 'tab' key, and from there its siblings can be focused with the arrow keys.
  tabs[focusedTab].setAttribute("tabindex", 0);
  tabs[focusedTab].focus();
}

function handleTabListKeydown(event) {
  const key = event.key;

  if (key === "ArrowRight" || key === "ArrowLeft") {
    if (key === "ArrowRight") {
      focusedTab++;
      // We have gone past the end, wrap around to the start
      if (focusedTab >= tabs.length) {
        focusedTab = 0;
      }
    } else if (key === "ArrowLeft") {
      focusedTab--;
      // We have gone before the start, wrap around to the end
      if (focusedTab < 0) {
        focusedTab = tabs.length - 1;
      }
    }
    updateTabFocus();
  }
}

function handleTabClick(event) {
  const target = event.target;
  const selectedTabIndex = tabs.indexOf(target);

  // unselect all the tabs, then select the clicked tab
  for (const tab of tabs) {
    tab.setAttribute("aria-selected", false);
  }
  target.setAttribute("aria-selected", true);

  // hide all the tab panels, then show the one that the clicked tab controls
  for (const panel of tabPanels) {
    panel.setAttribute("hidden", true);
  }
  container
    .querySelector(`#${target.getAttribute("aria-controls")}`)
    .removeAttribute("hidden");

  // move the tab underline to beneath the currently selected tab
  tabUnderline.style.transform = `translateX(${selectedTabIndex * 100}%)`;

  focusedTab = selectedTabIndex;
  updateTabFocus();
}
*/
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];

  document.querySelectorAll(selector).forEach((grid, i) => {
    var tmp = {
      index: i,
      offsetheight: grid.closest(`[data-equal]`).offsetTop,
    };
    this.offsetArrayArray.push(tmp);
  });

  this.diffrentsHeights = [];
  this.offsetArrayArray.forEach(function (e) {
    if (this.diffrentsHeights.includes(e.offsetheight) == false) {
      this.diffrentsHeights.push(e.offsetheight);
    }
  });

  this.diffrentsHeights.forEach(function (e) {
    var data = [];
    for (var i = 0; i < this.offsetArrayArray.length; i++) {
      if (this.offsetArrayArray[i].offsetheight == e) {
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].removeAttribute("style");
      getAllHeightArray.push(
        document.querySelectorAll(selector)[ele.index].offsetHeight
      );
    });

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].style.minHeight =
        getMaxHeight + 1 + "px";
    });
  });
};

window.setGridHeight(".cart_sample_content .grid__item .card-information__text");
window.setGridHeight(".cart_sample_content .grid__item .cart-item__discounted-prices");
window.setGridHeight(".cart_sample_content .grid__item .card-information__wrapper .price");
window.setGridHeight(".cart_sample_content .grid__item .card-information ");
window.setGridHeight(".cart_sample_content .grid__item .card-wrapper");
window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button .button");
window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button");

setTimeout(() => {
  window.setGridHeight(".cart_sample_content .grid__item .card-information__text");
  window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button .button");
  window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button");
  window.setGridHeight(".cart_sample_content .grid__item .cart-item__discounted-prices");
  window.setGridHeight(".cart_sample_content .grid__item .card-information__wrapper .price");  
window.setGridHeight(".cart_sample_content .grid__item .card-information ");
window.setGridHeight(".cart_sample_content .grid__item .card-wrapper");
  },2000) 
  
window.addEventListener('resize', function(event){
    window.setGridHeight(".cart_sample_content .grid__item .card-information__text");
    window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button .button");
    window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button");
    window.setGridHeight(".cart_sample_content .grid__item .cart-item__discounted-prices");
    window.setGridHeight(".cart_sample_content .grid__item .card-information__wrapper .price");  
window.setGridHeight(".cart_sample_content .grid__item .card-information ");
window.setGridHeight(".cart_sample_content .grid__item .card-wrapper");
});

setTimeout(function() {
    if(document.querySelector('.yotpo-pictures-gallery-title')) document.querySelector('.yotpo-pictures-gallery-title').textContent = 'Follow us @animamundiherbals';
}, 2000);

// ADA yopto slider title
{
  const checkInterval = setInterval(() => {
    const titleElement = document.querySelector('.yotpo-slider-title');

    if (titleElement) {
      clearInterval(checkInterval);
      titleElement.setAttribute('tabindex','0');
      titleElement.setAttribute('aria-label', `${titleElement.textContent}`);
    }
  }, 500);
}

let FilterValueURL = location.href.split("#")[1]?.toLocaleLowerCase().trim().replace(/\s+/g, '').replace(/-/g, '');
const locationSelect = document.getElementById('bta-location-select');
if (locationSelect) {
window.addEventListener('DOMContentLoaded', () => {

  if (FilterValueURL) {
    locationSelect.querySelectorAll("option").forEach((item) => {
      let dropdownText = item.innerText.toLocaleLowerCase().trim().replace(/\s+/g, '').replace(/-/g, '');
      console.log(dropdownText)

      if (dropdownText === FilterValueURL) {
        locationSelect.value = item.value;
        sessionStorage.setItem('selectedLocation', item.value);

        history.replaceState(null, null, location.pathname);
      }
    });
  } else {
    const savedLocation = sessionStorage.getItem('selectedLocation');
    if (savedLocation) {
      locationSelect.value = savedLocation;
    }
  }

  locationSelect.addEventListener('change', () => {
    const selected = locationSelect.value;
    sessionStorage.setItem('selectedLocation', selected);
    history.replaceState(null, null, location.pathname);
  });
});
}
  
